export default class Type {
	type = [
		'转归',
		'转回',
		'临时转移',
	]

	typeReason = [
		'血透',
		'腹透',
		'死亡',
		'放弃',
		'移植',
		'其他',
	]
	deathType = [
		'心血管',
		'脑血管',
		'肿瘤',
		'感染',
		'恶液质',
		'失血性',
		'猝死',
		'原因不明',
		'其它',
		'心肌梗死',
	]


}



// WEBPACK FOOTER //
// ./src/views/electronicMedicalRecord/patient/parts/outCome/types.ts